import { useQueryClient } from "@tanstack/react-query";
import produce from "immer";
import { getUUID } from "@annunciate/core";
import { BOOKMARK_DELETE } from "../queries/bookmark";
import { useMutation } from "./base";
export const useBookmarkDeleteMutation = () => {
    const client = useQueryClient();
    return useMutation(BOOKMARK_DELETE, {
        onSuccess: async (data) => {
            const bookmark = data;
            const uuid = getUUID(true);
            const key = ["bookmark", uuid, { contentId: bookmark.contentId }];
            client.setQueryData(key, (old) => {
                return produce(old || [], (draft) => {
                    const idx = draft.findIndex((b) => b.id === bookmark.id);
                    if (idx > -1) {
                        draft.splice(idx, 1);
                    }
                });
            });
            client.getQueryData(key);
        },
    }, (data) => data.result);
};
//# sourceMappingURL=useBookmarkDeleteMutation.js.map